export default function AboutFeatures() {
    return (
        <div className="overflow-hidden  py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-3 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                    <div className="lg:ml-auto lg:pl-4 lg:pt-4 xs:col-span-3 sm:col-span-3 md:col-span-2 lg:col-span-2">
                        <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                            <span className="text-we-are-yellow">
                                Tijdbesparend
                            </span>{" "}
                            voor de drukbezette mens
                        </p>
                        <p className="mt-6 text-lg leading-8 text-white">
                            Laten we eerlijk zijn: tijd is kostbaar. We hebben
                            allemaal een druk leven met werk, gezin en sociale
                            verplichtingen. Bij WE ARE snappen we dat je geen
                            uren per dag kunt missen of in de keuken wilt gaan
                            staan. Ons programma is ontworpen om efficiënt en
                            effectief te zijn. Korte, krachtige trainingen en
                            praktische gerechten die passen bij jouw leven. Zo
                            hou je tijd over voor wat echt belangrijk is terwijl
                            je geweldige resultaten behaald.
                        </p>
                        <picture>
                            <source
                                srcSet="/assets/about/webp/time.webp"
                                width="1440"
                                height="960"
                                type="image/webp"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                            <source
                                srcSet="/assets/about/time.jpg"
                                width="1440"
                                height="960"
                                type="image/jpeg"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                            <img
                                src="/assets/about/time.jpg"
                                width="1440"
                                height="960"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                        </picture>
                    </div>
                </div>
            </div>
            <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-32 xs:mt-8 sm:mt-8 md:mt-32 lg:mt-32">
                <div className="mx-auto grid max-w-2xl grid-cols-3 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                    <div className="lg:ml-auto lg:pl-4 lg:pt-4 xs:col-span-3 sm:col-span-3 md:col-span-2 lg:col-span-2">
                        <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                            <span className="text-we-are-yellow">Maatwerk</span>{" "}
                            omdat jij uniek bent
                        </p>
                        <p className="mt-6 text-lg leading-8 text-white">
                            Bij WE ARE begrijpen we dat iedereen zijn eigen
                            verhaal heeft. Jouw lichaam, jouw doelen en jouw
                            uitdagingen zijn uniek. Daarom geloven we niet in
                            een one-size-fits-all aanpak. We nemen de tijd om
                            jou echt te leren kennen en stellen een persoonlijk
                            plan op dat past bij jouw leven. We evalueren
                            wekelijks en passen aan waar nodig. Jouw glimlach
                            terug op het gezicht is ons doel.
                        </p>
                        <picture>
                            <source
                                srcSet="/assets/about/webp/custom.webp"
                                width="1440"
                                height="960"
                                type="image/webp"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                            <source
                                srcSet="/assets/about/custom.jpg"
                                width="1440"
                                height="960"
                                type="image/jpeg"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                            <img
                                src="/assets/about/custom.jpg"
                                width="1440"
                                height="960"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                        </picture>
                    </div>
                    <div className="flex items-start justify-end lg:order-first"></div>
                </div>
            </div>
            {/*  */}
            <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-32 xs:mt-8 sm:mt-8 md:mt-32 lg:mt-32">
                <div className="mx-auto grid max-w-2xl grid-cols-3 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                    <div className="lg:ml-auto lg:pl-4 lg:pt-4 xs:col-span-3 sm:col-span-3 md:col-span-2 lg:col-span-2">
                        <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                            <span className="text-we-are-yellow">
                                Kwaliteit boven kwantiteit
                            </span>{" "}
                            persoonlijke aandacht voorop
                        </p>
                        <p className="mt-6 text-lg leading-8 text-white">
                            We kunnen niet iedereen helpen, en dat proberen we
                            ook niet. Onze focus ligt op kwaliteit, niet op
                            kwantiteit. We willen je echt leren kennen tijdens
                            een kennismakingsgesprek om te zien of we een match
                            zijn. Wanneer er geen match is gaan we niet aan de
                            slag. Met een limiet van 30 intensief begeleide
                            leden zorgen we ervoor dat iedereen de aandacht
                            krijgt die hij of zij verdient. Bij ons ben je geen
                            nummer, maar een lid van de WE ARE familie.
                        </p>
                        <picture>
                            <source
                                srcSet="/assets/about/webp/quality.webp"
                                width="1440"
                                height="960"
                                type="image/webp"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                            <source
                                srcSet="/assets/about/quality.jpg"
                                width="1440"
                                height="960"
                                type="image/jpeg"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                            <img
                                src="/assets/about/quality.jpg"
                                width="1440"
                                height="960"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                        </picture>
                    </div>
                </div>
            </div>
            <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-32 xs:mt-8 sm:mt-8 md:mt-32 lg:mt-32">
                <div className="mx-auto grid max-w-2xl grid-cols-3 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                    <div className="lg:ml-auto lg:pl-4 lg:pt-4 xs:col-span-3 sm:col-span-3 md:col-span-2 lg:col-span-2">
                        <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                            <span className="text-we-are-yellow">
                                Fysiek en mentaal
                            </span>{" "}
                            pak het probleem bij de wortel aan
                        </p>
                        <p className="mt-6 text-lg leading-8 text-white">
                            WE ARE pakt het probleem bij de wortels aan. Echte
                            verandering begint namelijk van binnen. Het gaat
                            niet alleen om de kilo’s die je verliest, maar om de
                            gewoontes die je verandert. Bij WE ARE coachen we je
                            niet alleen fysiek, maar ook mentaal. We helpen je
                            om de patronen te doorbreken die je in de weg staan.
                            Alleen zo kun je een blijvende transformatie
                            realiseren.
                        </p>
                        <picture>
                            <source
                                srcSet="/assets/about/webp/physic.webp"
                                width="1440"
                                height="960"
                                type="image/webp"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                            <source
                                srcSet="/assets/about/physic.jpg"
                                width="1440"
                                height="960"
                                type="image/jpeg"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                            <img
                                src="/assets/about/physic.jpg"
                                width="1440"
                                height="960"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                        </picture>
                    </div>
                    <div className="flex items-start justify-end lg:order-first"></div>
                </div>
            </div>
            {/*  */}
            <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-32 xs:mt-8 sm:mt-8 md:mt-32 lg:mt-32">
                <div className="mx-auto grid max-w-2xl grid-cols-3 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                    <div className="lg:ml-auto lg:pl-4 lg:pt-4 xs:col-span-3 sm:col-span-3 md:col-span-2 lg:col-span-2">
                        <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                            <span className="text-we-are-yellow">
                                Exclusieve nazorg
                            </span>{" "}
                            jouw stok achter de deur
                        </p>
                        <p className="mt-6 text-lg leading-8 text-white">
                            Je doel behalen is één ding, maar het vasthouden is
                            een tweede. Daarom laten we je niet aan je lot over
                            zodra je je doelen hebt bereikt. Na het behalen van
                            je doel kan je gebruik maken van ons uitgebreide
                            nazorg abonnement. We blijven je ondersteunen,
                            motiveren en uitdagen. Maandelijkse gesprekken met
                            je coach, sportieve uitdagingen, verschillende
                            groepslessen en een zaal met gelijkgestemden zorgen
                            ervoor dat je op koers blijft. Geen zorgen over, en
                            geen stress van een terugval. Wij zijn er voor je,
                            elke stap van de weg, ervoor en erna.
                        </p>
                        <picture>
                            <source
                                srcSet="/assets/about/webp/unique.webp"
                                width="1440"
                                height="960"
                                type="image/webp"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                            <source
                                srcSet="/assets/about/unique.jpg"
                                width="1440"
                                height="960"
                                type="image/jpeg"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                            <img
                                src="/assets/about/unique.jpg"
                                width="1440"
                                height="960"
                                alt="Transformaties personal training Uden en Schijndel"
                                className="w-full h-82 object-cover mt-8"
                            />
                        </picture>
                    </div>
                </div>
            </div>
            <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-32 xs:mt-8 sm:mt-8 md:mt-32 lg:mt-32">
                <div className="mx-auto grid max-w-2xl grid-cols-3 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                    <div className="lg:ml-auto lg:pl-4 lg:pt-4 xs:col-span-3 sm:col-span-3 md:col-span-2 lg:col-span-2">
                        <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                            <span className="text-we-are-yellow">
                                Bewezen resultaten
                            </span>{" "}
                            geen loze beloftes
                        </p>
                        <p className="mt-6 text-lg leading-8 text-white">
                            We kunnen wel zeggen dat we de beste zijn, maar we
                            laten het liever zien. Onze leden zijn het levende
                            bewijs dat de WE ARE methode werkt. Transformaties,
                            succesverhalen, mensen die hun leven hebben
                            veranderd. Dat is waar we het voor doen. Bekijk ze
                            snel op onze{" "}
                            <a
                                href={route("results")}
                                className="text-we-are-yellow"
                            >
                                resultaten
                            </a>{" "}
                            pagina!
                        </p>
                    </div>
                    <div className="flex items-start justify-end lg:order-first"></div>
                </div>
            </div>
        </div>
    );
}
